import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
// Declare wistia-player as a valid JSX element
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'wistia-player': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement> & {
        'media-id': string;
        aspect?: string;
      }, HTMLElement>;
    }
  }
}
const testimonials = [{
  mediaId: 's93h532r85',
  aspect: '0.5625',
  quote: 'Son segundos. La gente quiere todo ya.',
  name: 'Juan Felipe Sánchez',
  role: 'Experto en Tráfico Digital · +$3M facturados con Ads · Colombia'
}, {
  mediaId: 'vcr9avikvy',
  aspect: '0.5581395348837209',
  quote: 'El momento que llaman es el momento perfecto para amarrar la venta.',
  name: 'Eliadys Hernández',
  role: 'Asesor Certificado de Seguros · Houston, Texas'
}, {
  mediaId: 'xp462wbhzv',
  aspect: '0.5625',
  quote: 'Una vez que llega el lead — inmediatamente.',
  name: 'Juan Ernesto Gómez',
  role: 'Empresario de Servicios y Terrenos · Houston, Texas'
}];
export function SocialProof() {
  useEffect(() => {
    // Inject Wistia player runtime once
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    // Inject each video's embed script
    testimonials.forEach(t => {
      const mediaScript = document.createElement('script');
      mediaScript.src = `https://fast.wistia.com/embed/${t.mediaId}.js`;
      mediaScript.async = true;
      mediaScript.type = 'module';
      document.body.appendChild(mediaScript);
    });
  }, []);
  return <section className="py-24 bg-navy relative dot-pattern" data-id="element-160">
      <div className="max-w-7xl mx-auto px-6" data-id="element-161">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-162">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-163">
            ¿Por Qué Responder Rápido lo Cambia Todo?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-muted leading-relaxed" data-id="element-164">
            Traffickers, asesores y empresarios con años de experiencia
            coinciden en lo mismo.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-165">
          {/* Active testimonials with video */}
          {testimonials.map((t, index) => <motion.div key={t.mediaId} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="card-glow p-6 flex flex-col h-full border-primary/30 shadow-[0_0_30px_rgba(0,180,216,0.15)]" data-id="element-166">
              {/* Wistia Video Player */}
              <div className="relative rounded-xl overflow-hidden mb-6 border border-primary/20 bg-navy-deep" data-id="element-167">
                <wistia-player media-id={t.mediaId} aspect={t.aspect} style={{
              display: 'block',
              width: '100%'
            }} data-id="element-168" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-169">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-primary fill-primary" data-id="element-170" />)}
              </div>

              {/* Anchor phrase */}
              <p className="text-primary font-semibold text-lg italic mb-5 leading-snug" data-id="element-171">
                "{t.quote}"
              </p>

              {/* Name & role */}
              <div className="pt-5 mt-auto border-t border-primary/10" data-id="element-172">
                <h4 className="text-white font-bold text-base mb-1" data-id="element-173">
                  {t.name}
                </h4>
                <p className="text-muted text-sm leading-relaxed" data-id="element-174">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}